import { Trend } from '../model'

export * from './TrendIcon'
export * from './trend-triangle'

export const trendColor = (trend: Trend.Trend) =>
  trend === Trend.Down ? 'var(--down-9)' : 'var(--up-9)'

export const colorCSSVar = (
  trend: Trend.Trend,
  options: {
    mode: 'bright' | 'candle'
  },
) =>
  Trend.match(trend, {
    Down: () =>
      options.mode === 'candle' ? 'var(--down-9)' : 'var(--downAccent-9)',
    Neutral: () =>
      options.mode === 'candle'
        ? 'var(--neutral-11)'
        : 'var(--neutralAccent-11)',
    Up: () => (options.mode === 'candle' ? 'var(--up-9)' : 'var(--upAccent-9)'),
  })
